<template>
    <div class="flex-1 mt-1 bg-gray-100 px-4 pt-8 shadow-lg items-center">
        <div class="bg-white w-fullrounded-lg shadow">
            <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
                <div class="flex">
                            <button
                    :class="$colors.primary"
                    class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
                    @click="RouterBack()"
                >
                    <i class="material-icons">chevron_left</i>
                </button>
                    <div class="text-xl font-semibold text-blue-700"> Update shipping</div>
                </div>
            </div>
            
            <div class="px-6 mt-3">
                 <!-- ****************************************Shipping information********************************* -->
                <div class="flex w-full">
                    <div class="flex space-x-2 w-full shadow-xs mt-1 mb-1 rounded-lg">
                        <div class="flex w-full justify-between items-center h-auto p-6 ">
                            <div class="flex w-full">
                                 <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-500">local_mall</i>
                                </span>
                                <div class="ml-3 w-full p-2">
                                    <div class="w-full flex text-base font-semibold text-gray-600">
                                        <p class="w-1/2">Shipping Informations</p>
                                    </div>
                                    <div class="bg-white rounded-lg p-6 pb-0">
                                        <div class="grid lg:grid-cols-2 gap-6">
                                           <div v-if="$route.params.id && (currentUser.type=='Admin' || currentUser.type=='Administrateur' || currentUser.type=='StockManager')" class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="shippdate" class="bg-white text-gray-700 px-1">Shipping date
                                                            <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <input id="shippdate" :disabled="['received','paid','processed'].indexOf(formData.status) === -1?false:true"  type="date"  v-model="formData.date" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                                </p>
                                           </div>
                                            <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                                <p>
                                                    <label for="customerAddress" class="bg-white text-gray-700 px-1" >Address shipping<span :class="$colors.required">*</span></label>
                                                </p>
                                                </div>
                                                <p>
                                                <textarea id="customerAddress" type="text" v-model="formData.address"
                                                    class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                                </p>
                                            </div>
                                           
                                            <div class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                    <label for="category" class="bg-white text-gray-700 px-1">Zone shipping <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                <select :disabled="currentUser.type=='Courier'" id="type" @change="getCourierZone($event)" v-model="formData.zone" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                    <option selected disabled :value="null">zone name</option>
                                                    <option v-for="(zone,index) in zones" :key="index" :value="zone" :id="zone._id">
                                                        {{ zone.name }}
                                                    </option>
                                                </select>
                                                </p>
                                            </div>
                                             <div class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                        <label for="courier" class="bg-white text-gray-700 px-1">Courier <span :class="$colors.required">*</span></label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                    <v-select v-bind:class="{ disabled: currentUser.type=='Courier' }" label="fullName" v-model="formData.courier" :options="courier" ></v-select>
                                                    </p>
                                                </div>
                                            
                                         
                                            <!-- <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="status" class="bg-white text-gray-700 px-1">Status <span :class="$colors.required">*</span>
                                                    </label>
                                                </p>
                                            </div>
                                            <p>
                                                <select name="status" autocomplete="type"  v-model="formData.status" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                    <option class="bg-white" selected :value="null"> Status </option>
                                                    <option class="bg-white text-gray-600" v-for="(value, index) in statusShipping" :key="index" :value="value">
                                                        {{ value }}
                                                    </option>
                                                </select>
                                            </p>
                                           </div> -->
                                         <div v-if="formData.type!='normal'" class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="type" class="bg-white text-gray-700 px-1">Type <span :class="$colors.required">*</span>
                                                        </label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <select  v-model="formData.type" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                        <option class="bg-white" selected :value="null"> Type </option>
                                                        <option class="bg-white text-gray-600" v-for="(value, index) in typesShipp" :key="index" :value="value">
                                                            {{ value }}
                                                        </option>
                                                    </select>
                                                </p>
                                            </div>
                                        </div>
                                    </div>     
                                </div>    
                            </div>    
                        </div>
                    </div>
               </div>
                 <!-- shipping cancelled -->
                <div  v-if="formData.status=='cancelled'"  class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                    <div class="flex w-full mt-1">
                        <span class="rounded-full h-12 w-12 bg-gray-200">
                            <i class="material-icons p-3 text-blue-400">local_mall</i>
                        </span>
                        <div class="ml-5 w-full pb-4">
                            <div class="text-base mt-1 font-semibold text-gray-600 pb-10">Products returned</div>
                            <div class="w-full space-y-4">
                                <div class="w-full">
                                    <table class="min-w-full w-full">
                                        <thead class="text-white">
                                            <tr class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                <th class="p-2 justify-center">Image</th>
                                                <th class="p-2 justify-center">Name</th>
                                                <th class="p-2 justify-center">Quantity Sent</th>
                                                <th class="p-2 justify-center">Quantity Returned</th>
                                            </tr>
                                        </thead>
                                        <tbody class="flex-1 sm:flex-none">
                                            <tr v-for="(it,index) in formData.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                    <div> <img :alt="it.product.name" :src="it.product.picture" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                                </td>
                                                <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                                <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <span>{{it.quantity}}</span>
                                                </td>
                                                <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <input id="Defective" type="number" :max="it.quantity" min="0" v-model="it.product.returned" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>  
              <!-- end shipping cancelled -->
                 <!--*******************  Product change ***************************************-->
           <div  v-if="formData.type=='change'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                <div class="flex w-full mt-1">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-blue-400">local_mall</i>
                    </span>
                    <div class="ml-5 w-full pb-4">
                        <div class="text-base mt-1 font-semibold text-gray-600 pb-10">Products change</div>
                        <div class="w-full space-y-4">
                            <div class="w-full">
                                <table class="min-w-full w-full">
                                    <thead class="text-white">
                                        <tr class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                            <th class="p-2 justify-center">Image</th>
                                            <th class="p-2 justify-center">Name</th>
                                            <th class="p-2 justify-center">Qty</th>
                                            <th class="p-2 justify-center">Qty Returned</th>
                                            <th v-if="CheckQteDefecteuseexist" class="p-2 justify-center">Qty Defective</th>
                                        </tr>
                                    </thead>
                                    <tbody class="flex-1 sm:flex-none">
                                        <tr v-for="(it,index) in formData.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                <div> <img :alt="it.product.name" :src="it.product.picture" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                <input id="Defective" :disabled="CheckQteDefecteuseexist" type="number" :max="it.quantity" min="0" v-model="it.product.qteChange" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                            </td>
                                             <td v-if="CheckQteDefecteuseexist" class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity-it.product.qteChange }}</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
        <!--  end product change -->    
              <div class="mt-6 pt-3 flex justify-center p-10">
                <button
                    class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
                    @click="save">
                    Save
                </button>
               </div>
                <div class=" flex justify-center p-10">
                     <button @click="startConfirmation" :class="$colors.newColor" class="rounded focus:outline-none outline-none btn-more text-white hover:text-red-500">
                        Show more info <i class="material-icons" style="transition: 0.3s" :style="showMoreInfo? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                    </button>
                </div>    
               <div v-if="showMoreInfo" >
                    <div class="flex w-full space-x-2">
                        <!-- ********************************************************Customer information **********************************-->
                        <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full">
                                <span class="rounded-full h-12 w-12 bg-gray-200"><i class="material-icons p-3 text-blue-400">person</i></span>
                                <div class="ml-5 w-full">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">Customer information</div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="w-full space-y-4">
                                        <div class="flex">
                                            <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="customerFullName" class="bg-white text-gray-700 px-1">Full name <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <input id="customerFullName"  type="text" v-model="formData.order.customer.fullName" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="customerPhone" class="bg-white text-gray-700 px-1">Phone <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input id="customerPhone"  type="text" v-model="formData.order.customer.phone" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                            </p>
                                        </div>
                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="customerAddress" class="bg-white text-gray-700 px-1">Address <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <textarea id="customerAddress"  type="text" v-model="formData.order.customer.address" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                            </p>
                                        </div>
                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="customerShippingAddress" class="bg-white text-gray-700 px-1">Shipping address <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <textarea id="customerShippingAddress"  type="text" v-model="formData.order.customer.shippingAddress" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ****************************** Order Information *********************************************-->
                        <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full mt-2">
                                <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                                </span>

                                <div class="ml-5 w-full">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10"> Order information </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="w-full space-y-4">
                                        <div class="flex">
                                            <div
                                                class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="source" class="bg-white text-gray-700 px-1">Order source <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <input id="source"  type="text" v-model="formData.order.source" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="sourceLink" class="bg-white text-gray-700 px-1">Order source link<span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input id="sourceLink"  type="text" v-model="formData.order.sourceLink" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                            </p>
                                        </div>

                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="date" class="bg-white text-gray-700 px-1">Order date <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input id="date"  type="datetime-local" v-model="formData.order.date" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                            </p>
                                        </div>

                                        <!-- <div v-if="currentUser.type == 'Admin' || currentUser.type=='Administrateur'" class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="seller" class="bg-white text-gray-700 px-1">Seller <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input  disabled  type="text" v-model="formData.seller" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                        
                                            </p>
                                        </div> -->
                                        <div v-if="currentUser.type == 'Admin' || currentUser.type=='Administrateur'"
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="comment" class="bg-white text-gray-700 px-1">Comment <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <textarea id="comment"  type="text" v-model="formData.order.comment" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-6 pt-3 flex justify-center p-10">
                        <button
                            class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
                            @click="saveOrder">
                            Save
                        </button>
                     </div>
                    <!-- ********************************************************Product Table assigned to order **********************************-->
                    <div class="flex w-full">
                        <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg mb-10">
                            <div class="flex w-full justify-between items-center h-auto p-6">
                                <div class="flex w-full">
                                    <span class="rounded-full h-12 w-12 bg-gray-200">
                                        <i class="material-icons p-3 text-blue-500">local_mall</i>
                                    </span>
                                    <div class="ml-3 w-full p-2 pb-8">
                                        <div class="w-full flex text-base font-semibold text-gray-600">
                                            <p class="w-1/2">Order</p>
                                        </div>
                                        <div class="mt-4 overflow-x-auto">
                                            <table v-if="formData.order.details" class="min-w-full leading-normal">
                                                <thead>
                                                    <tr> 
                                                        <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">Image</th>
                                                        <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"> Name </th>
                                                        <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">Unit Price</th>
                                                        <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"> Quantity</th> 
                                                        <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"> Amount</th>                                 
                                                    </tr>
                                                </thead>
                                                <tbody v-for="(item, index) in formData.order.details" :key="index">
                                                    <tr>
                                                        <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                                                <img  :src="item.product.picture" class="h-16 w-16 rounded-md">
                                                            </div>
                                                        </td>
                                                        <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                                                {{ item.product.name }}
                                                            </div>
                                                        </td>

                                                        <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                                                <sup v-if="formData.warehouse.currency">{{formData.warehouse.currency}}</sup> {{ item.unitPrice }} 
                                                            </div>
                                                        </td>

                                                        <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                                            <div class="flex space-x-6">                                   
                                                                <span :class="$colors.textPrimary" class="px-1 text-gray-700 text-sm rounded-md w-4 h-6 flex items-center focus:outline-none">
                                                                    {{ item.quantity }}
                                                                </span>                                                        
                                                            </div>
                                                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                                        </td>
                                                         <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                                                <sup v-if="formData.warehouse.currency">{{formData.warehouse.currency}}</sup> {{ item.unitPrice*item.quantity }} 
                                                            </div>
                                                        </td>

                                              
                                                    </tr>
                                                </tbody>
                                                <tbody><tr><td colspan="5" class="px-6 text-right py-2 whitespace-no-wrap border-gray-200"><div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">  Total price: {{TotalPrice()}} <sup v-if="formData.warehouse.currency">{{formData.warehouse.currency}}</sup> </div></td></tr></tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ************************************************************************************************-->
                </div>
            </div>
          
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            currentUser: { type: Object},
            idWharhouse: { type: Object}
        },
        data() {
            return {
                formData: {
                    order:{
                        customer: {},
                        seller:{}
                    }   
                },
                searchText: "",
                quantity: 0,
                status: [],
                products: [],
                show_modal: true,
                limit: 2,
                paginate: {
                    total: 0,
                    currentpage: 1,
                    lastpage: 1,
                    per_page: 0,
                },
                productselected: [],
                numberItemRepeated: 0,
                sellers: [],
                zones:[],
                courier :[],
                statusShipping: ["queued", "prepared", "shipped",'received','paid','cancelled','refunded','reprogrammed'],
                typesShipp:[ "pendingchange", "change"],
                showMoreInfo:false,
                CheckQteDefecteuseexist:false,
            };
        },
        async mounted() {
            if (this.currentUser.type == "Admin" || this.currentUser.type=='Administrateur')  await this.getSellers();
             else this.formData.order.seller = this.currentUser._id;

            await this.getStatus();
            await this.GetShipping();
            await this.getProducts({});
            await this.getZones();
            await this.getCurrentCourierZone(this.formData.zone);
            await this.CheckQteDefecteuse();
            if (this.formData.refund) {
                let indexss = this.statusShipping.indexOf("paid");
                if (indexss > -1) this.statusShipping.splice(indexss, 1);
            }
             if (this.currentUser.type == "Courier") {
               const index = this.statusShipping.indexOf("queued");
               if (index > -1) this.statusShipping.splice(index, 1);
            }
            if (this.currentUser.type == "StockManager") {
               this.statusShipping.splice(3,4);
            }
        },
        methods: {
             RouterBack: function() {
                this.$router.back();
                },
            TotalPrice(){
                let Total=0;
                    for (const element of this.formData.order.details) {
                        Total+=element.unitPrice * element.quantity;
                    }
                    return Total;
             },
             async CheckQteDefecteuse(){
                this.CheckQteDefecteuseexist=false;
                if(this.formData.type=='change' ){
                        for (let i in this.formData.order.details) {
                            const filters = {
                            product: this.formData.order.details[i].product._id,
                            order: this.formData.order._id,
                            shipping: this.formData._id,
                            };
                        const res = await this.$server.search("stockHistories", filters);
                        
                        if(typeof res.content.results !== 'undefined') {
                            this.formData.order.details[i].product.qteChange=res.content.results[0].quantity;
                            this.CheckQteDefecteuseexist=true;
                        }
                        }
                }    
            }, 
             async getCurrentCourierZone(id){
                 if(id){
                    const filter = {
                        type: 'Courier',
                        zones:id._id
                    };
                    const res = await this.$server.search("users",filter);
                    if (res.content.results) {
                        this.courier = res.content.results;
                    } else this.courier = [];
                }else this.courier = [];
             }, 
              async getCourierZone(event){
                const filter = {
                    type: 'Courier',
                    zones:event.target.options[event.target.options.selectedIndex].id
                };
                const res = await this.$server.search("users",filter);
                if (res.content.results) {
                    this.courier = res.content.results;
                } else this.courier = [];
            },
             startConfirmation() {
                this.showMoreInfo =  !this.showMoreInfo ;
             },
            async getZones() {
                const res = await this.$server.search("zones");
                if (res.content.results) this.zones = res.content.results;
                else this.zones = [];
            },
            async getUser() {
                const res = await this.$server.me("users");
                //console.log(res);
                if (res.content) this.currentUser = res.content;
                else this.currentUser = {};
            },
            async getProducts(filters) {
                if (this.formData.order.seller) filters.seller = this.formData.order.seller._id;

                const res = await this.$server.search("products", filters);
                if (res.content.results) {
                    this.products = res.content.results;
                    this.paginate.total = res.content.total;
                    this.paginate.lastpage = res.content.last_page;
                    this.paginate.per_page = res.content.per_page;
                    this.paginate.currentpage = res.content.current_page;

                    for (let i in this.products) {
                        this.products[i].quantity = this.products[i].quantity.inStock;
                        /*if (this.products[i].category)
                          this.products[i].category = this.products[i].category.name;*/
                        if (this.products[i].seller)
                            this.products[i].seller = this.products[i].seller.username;
                    }
                } else this.products = [];
            },

            async getStatus() {
                const res = await this.$server.search("status");
                if (res.content.results) this.status = res.content.results;
                else this.status = [];
            },
            async save() {
                console.log('oooooooooooooooooook',this.formData.order.seller)
                    this.formData.order.seller = this.formData.order.seller._id;
                    const data = await this.$server.update("shippings", this.formData);
                    if (data._id) {
                        console.log('yessss')
                        alert("Shippings updated", "success");
                        await this.GetShipping();
                    }
                     
            },
            async saveOrder(){
               // console.log('this.formData.order',this.formData.order)
                const data = await this.$server.update("orders", this.formData.order);
                    if (data._id) {
                        alert("Order updated", "success");
                    }
            },
            checkData() {
                if (this.formData.order.source && this.formData.order.sourceLink && this.formData.order.date && this.formData.order.details.length > 0 && this.formData.order.customer) return true;
                else return false;
            },

            removeProduct(data, index) {
                this.$confirm("Are you sure you want to delete this product?").then(
                    async (res) => {
                        let pos = this.formData.order.details
                            .map(function (e) {
                                return e.product._id;
                            })
                            .indexOf(data._id);

                        this.formData.order.details.splice(pos, 1);
                        data.product.check = false;
                        alert(`Product deleted !`, "success");
                    }
                );
            },

            addProductsToTemp(data, index) {
                if (data.check) {
                    const detail = {
                        product: data,
                        unitPrice: 1,
                        category: data.category._id,
                        quantity: 1,
                    };

                    let found = 0;
                    for (let i = 0; i < this.formData.order.details.length; i++) {
                        if (this.formData.order.details[i].product._id == data._id) {
                            found = found + 1;
                            this.numberItemRepeated = this.numberItemRepeated + 1;
                        }
                    }
                    if (found >= 1) {
                    } else {
                        this.productselected.push(detail);
                    }
                } else {
                    let pos = this.productselected
                        .map(function (e) {
                            return e.product._id;
                        })
                        .indexOf(data._id);
                    this.productselected.splice(pos, 1);
                }
            },

            addQuantity(index) {
                this.formData.order.details[index].quantity++;
            },
            removeQuantity(index) {
                if (this.formData.order.details[index].quantity <= 1) {
                } else {
                    this.formData.order.details[index].quantity--;
                }
            },
            ViderTable() {
                //console.log("HI SOUKA");
                this.productselected = [];
            },
            OpenPopUp() {
                this.getProducts({});
                document.getElementById("myModal").showModal();
            },
            ConfirmOperation() {
                let fount = 0;
                for (let i = 0; i < this.productselected.length; i++) {
                    this.formData.order.details.push(this.productselected[i]);
                }
                this.productselected = [];
                if (this.numberItemRepeated > 0) {
                    alert(`There are many products already added!`, "success");
                }
                this.numberItemRepeated = 0;
                //console.log("confirmed");
                document.getElementById("myModal").close();
            },
            closePopUp() {
                //console.log("close");
                document.getElementById("myModal").close();
            },
            async GetShipping() {
                if (this.$route.params.id) {
                    const editData = await this.$server.get("shippings", {
                        id: this.$route.params.id,
                    });
                    this.formData = editData.content;
                    this.formData.order.date = this.$moment(this.formData.order.date).format('yyyy-MM-DDTHH:mm');
                    this.formData.date = this.$moment(this.formData.date).format('yyyy-MM-DD');
                }
                console.log('this.formData',this.formData)
            },
            async getSellers() {
                const filter = {
                    type: "Seller",limit:4000
                };
                const res = await this.$server.search("users", filter);
                if (res.content.results) this.sellers = res.content.results;
                else this.sellers = [];
            },
        },

        computed: {
            resultSearchUsers() {
                if (this.searchText) {
                    return this.products.filter((product) => {
                        var regex = new RegExp(this.searchText, "i");

                        return regex.test(product.name);
                    });
                } else {
                    return this.products;
                }
            },
        },

        /************************************* Pagination **************************************************/
    };
</script>

<style>
    .btn-more i{
        display: block;
    }
    .toggle__dot {
        transition: all 0.3s ease-in-out;
    }

    input:checked~.toggle__dot {
        transform: translateX(100%);
        background-color: #68d391;
    }

    /* animation for vue transition tag */
    dialog[open] {
        animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
    }

    dialog::backdrop {
        background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
        backdrop-filter: blur(3px);
    }

    @keyframes appear {
        from {
            opacity: 0;
            transform: translateX(-3rem);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>